/** Maximum upload size: 20 MiB (binary). Reject files strictly larger than this. */
export const MAX_UPLOAD_FILE_SIZE_BYTES = 20 * 1024 * 1024;

export const MAX_UPLOAD_FILE_SIZE_LABEL = "20";

/**
 * @param {File | null | undefined} file
 * @returns {boolean} true if the file must be rejected (missing, bad size, or over limit)
 */
export function fileExceedsMaxUploadSize(file) {
  if (!file || typeof file.size !== "number" || file.size < 0) return true;
  return file.size > MAX_UPLOAD_FILE_SIZE_BYTES;
}

/**
 * @param {File} file
 * @returns {string} User-facing message for oversize file
 */
export function maxUploadSizeExceededMessage(file) {
  const name = file?.name || "This file";
  return `${name} exceeds the ${MAX_UPLOAD_FILE_SIZE_LABEL} MB limit. Choose a smaller file.`;
}

/**
 * @param {File[]} files
 * @returns {number} Sum of file.size in bytes (invalid sizes treated as 0)
 */
export function sumFileSizesBytes(files) {
  if (!Array.isArray(files)) return 0;
  return files.reduce((sum, f) => {
    if (!f || typeof f.size !== "number" || f.size < 0) return sum;
    return sum + f.size;
  }, 0);
}

/** True if combined size of files exceeds the max allowed for one batch/upload. */
export function batchTotalExceedsMaxUploadSize(files) {
  return sumFileSizesBytes(files) > MAX_UPLOAD_FILE_SIZE_BYTES;
}

export function cumulativeMaxUploadExceededMessage(totalBytes) {
  const mb = (totalBytes / (1024 * 1024)).toFixed(1);
  return `Total size of selected files is ${mb} MB, which exceeds the ${MAX_UPLOAD_FILE_SIZE_LABEL} MB limit for this upload. Remove some files or upload in smaller batches.`;
}
